import { render, staticRenderFns } from "./CouponManagement.vue?vue&type=template&id=ff758a08&scoped=true"
import script from "./CouponManagement.vue?vue&type=script&lang=js"
export * from "./CouponManagement.vue?vue&type=script&lang=js"
import style0 from "./CouponManagement.vue?vue&type=style&index=0&id=ff758a08&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff758a08",
  null
  
)

export default component.exports